export const UserProjectRoleActionExtension: IUserProjectRoleActionExtensionItem[] = [];
export interface IUserProjectRoleActionExtensionItem {
  name: string;
  value: string;
}
